import React, { useState } from "react";
import styled from "styled-components";
import { Row, Col, Card } from "antd";
import LoaderGif from "../../assets/images/ie_loader.gif";
import Catalog from "../../assets/images/checkout.jpg";
import { BiCheckDouble } from "react-icons/all";
const CategoryCardWrapper = styled(Card)`
  min-height: 250px;
  .ant-card-body {
    padding: 0;
  }
  // margin-bottom:${(props) => (props.StorePreview ? "0px" : "20px")}
  margin-top: ${(props) => (props.StorePreview ? "3rem" : "40px")};
`;
export default function Category({
  checkProgress,
  isImageTrue,
  StorePreview,
  checkoutValue,
  moveBackAndForward
}) {
  const [isBorder, setBorder] = useState("Standard Products");
  return (
    <Row style={{ marginTop: "3rem" }}>
      <Col xl={24} xs={24} sm={24}>
        <CategoryCardWrapper
          categorayName={isBorder}
          StorePreview={StorePreview}
        >
          <Row justify="start">
            {isImageTrue ? (
              <Col
                span={12}
                style={{
                  position: "relative",
                  padding: "15px",
                }}
                className="text-left"
              >
                <img
                  src={Catalog}
                  style={{
                    position: "absolute",
                    backgroundRepeat: "no-repeat",
                    top: "-20px",
                  }}
                />
              </Col>
            ) : (
              <Col xl={14}>
                <h5 className="text-left" style={{ padding: "15px" }}>
                  Categories
                </h5>
              </Col>
            )}
          </Row>

          <Row style={{ padding: "1rem", marginTop: "-15px" }}>
            {checkProgress.map((item, index) => {
              console.log("inside progress", index,item);
              return (
                <Col span={24} style={{ padding: "0.5rem" }}>
                  <Row onClick={() => moveBackAndForward(index, item)}>
                    <Col span={20}>
                      {" "}
                      <h3
                        className="text-left"
                        style={{
                          fontSize: "15px",
                          cursor: "pointer",
                          color:
                            item.isChecked || checkoutValue === item.name
                              ? "#009688"
                              : "lightgrey",
                        }}
                      >
                        {item.name}
                      </h3>
                    </Col>
                    {item.isChecked && (
                      <Col span={4}>
                        <BiCheckDouble size={"25"} color="#009688" />{" "}
                      </Col>
                    )}
                  </Row>
                </Col>
              );
            })}
            {/* <Col span={24} style={{ padding: "0.5rem" }}>
              <Row>
                <Col span={20}>
                  {" "}
                  <h3 className="text-left" style={{ color: "#009688" }}>
                    Billing Address
                  </h3>
                </Col>
                <Col span={4}>
                  <BiCheckDouble size={"25"} color="#009688" />{" "}
                </Col>
              </Row>
            </Col>
            <Col span={24} style={{ padding: "0.5rem" }}>
              <h3 className="text-left" style={{ color: "lightgrey" }}>
                Shipping Address
              </h3>
            </Col>
            <Col span={24} style={{ padding: "0.5rem" }}>
              <h3 className="text-left " style={{ color: "lightgrey" }}>
                Order Notes
              </h3>
            </Col>
            <Col span={24} style={{ padding: "0.5rem" }}>
              <h3 className="text-left" style={{ color: "lightgrey" }}>
                Payment Method
              </h3>
            </Col>
            <Col span={24} style={{ padding: "0.5rem" }}>
              <h3 className="text-left" style={{ color: "lightgrey" }}>
                Order Review
              </h3>
            </Col> */}
          </Row>
          {/* {isLoadingCategory ? (
            <img src={LoaderGif} height={"60"} width={"60"} />
          ) : (
            (categorey || []).map((item) => {
              return (
                <Row
                  justify="start"
                  style={{
                    border:
                      isBorder === item.name ? "solid 1px #09c1b2" : "none",
                    background: isBorder === item.name ? "#f1f1f1" : "none",
                  }}
                  className="primary-color category-border pointer-cursor"
                  onClick={() => {
                    setBorder(item.name);
                    abc(item);
                  }}
                >
                  <Col xl={24}>
                    <h2 className="text-left pointer-cursor categories-heading">
                      {item.name}
                    </h2>
                  </Col>
                </Row>
              );
            })
          )} */}
        </CategoryCardWrapper>
      </Col>
    </Row>
  );
}
